export var QueryType;
(function (QueryType) {
    QueryType["In"] = "IN";
})(QueryType || (QueryType = {}));
//# sourceMappingURL=query.types.js.map